import React from 'react';
import Inicio from '../components/Inicio';

function Home() {
    return (
        <>
            <Inicio />
        </>
    );
}

export default Home;
